const FRAME_DEFINITIONS = {
  belonging: {
    title: 'Belonging and Contributing',
    focus: [
      'sense of connectedness to others',
      'forming relationships and contributing as part of a group, community, and the natural world',
      'developing understanding of how people relate to one another and to the world around them',
    ],
  },
  selfRegulation: {
    title: 'Self-Regulation and Well-Being',
    focus: [
      'understanding own thoughts and feelings and respecting that others may have different ones',
      'managing emotions and impulses, dealing with distractions, recognizing consequences',
      'awareness of physical and mental health and wellness',
    ],
  },
  literacyMath: {
    title: 'Demonstrating Literacy and Mathematics Behaviours',
    focus: [
      'communicating thoughts and feelings using language, images, materials, and other forms of expression',
      'literacy behaviours - using language and stories, beginning to think critically, read, and write',
      'mathematics behaviours - using number and pattern, processing information, grasping mathematical relationships',
      'curiosity about literacy and mathematics; love of learning for life',
    ],
  },
  problemSolving: {
    title: 'Problem Solving and Innovating',
    focus: [
      'desire to explore the world out of natural curiosity, developing mind, senses, and body',
      'making meaning by asking questions, testing theories, and using creative and analytical thinking',
      'confidence to explore innovative thoughts and apply ideas when interacting with others and the world',
    ],
  },
}

export function buildFramePrompt(frameKey, charLimit) {
  const frame = FRAME_DEFINITIONS[frameKey]
  const focusBullets = frame.focus.map((f) => `  - ${f}`).join('\n')

  return `

You are an Ontario Kindergarten educator writing the "Key Learning / Growth in Learning / Next Steps in Learning" narrative for the **${frame.title}** frame of the Kindergarten Communication of Learning: Final Observations report (3046E, issued at end of year).

This frame focuses on children's:
${focusBullets}

Write a clear, observational comment in English describing the child's learning in a play-based kindergarten environment, grounded in concrete observations from classroom activity that connect to this specific frame.

Structure the comment in three short sections:
  1. Key Learning - what the child knows and can do, with concrete observations.
  2. Growth in Learning - how the child has developed over the year.
  3. Next Steps in Learning - what the child will work toward next, written in encouraging language.

Use gender-neutral language unless the teacher specifies otherwise. Do not assume gender without precedent.

Keep the tone warm, specific, and oriented toward the family as the audience. Avoid jargon, letter grades, or numerical scores. Stay within the scope of the ${frame.title} frame - do not stray into other frames' content.

The comment cannot exceed ${charLimit} characters.

`
}
